module.exports = __webpack_public_path__ + "static/media/panel_questionmark.98e56c1d.png";